export default {
  isNumber(value) {
    if (value === 0) return true
    return value && typeof value == "number"
  },
  checkArg(cond, msg) {
    if (!cond) throw new Error(msg)
  },
  userRating(film, id) {
    const rating = film.ratings.find(r => r.user_id == id)
    return rating ? rating.rating : null
  },
  runtimeText(film) {
    return film.runtime ? `${film.runtime} mins` : "---"
  },
  shorten(text, maxLen) {
    if (text.length <= maxLen) {
      return text
    }
    return text.slice(0, maxLen-3) + "..."
  },
  numericCompare(dir, selector) {
    return (a, b) => {
      const aval = selector(a)
      const bval = selector(b)
      if (aval === undefined && bval === undefined) return 0
      if (aval === undefined) return -dir
      if (bval === undefined) return dir
      if (aval === null && bval === null) return 0
      if (aval === null) return -dir
      if (bval === null) return dir
      if (aval > bval) return dir
      if (aval < bval) return -dir
      return 0
    }
  },
  stringCompare(dir, selector) {
    return (a, b) => dir * selector(a).localeCompare(selector(b), "en", {sensitivity: "base"})
  }
}
